/* eslint-disable max-len */
import {
  useTranslate,
  FunctionField,
  useList,
  ListContextProvider,
  useDeleteMany
} from "react-admin";
import CustomDataGrid from "./CustomDataGrid";
import ListDotsActions from "./ListDotsActions";
import { Link } from "react-router-dom";
import { ListItemButton } from "@mui/material";
import * as User from "providers/user";
import { useState } from "react";

const ServiceAddOnsList = ({
  addOnsData,
  refresh
}: {
  addOnsData: any;
  refresh: () => void;
}) => {
  const translate = useTranslate();
  const { permissions } = User.useUser();
  const listContext = useList({ data: addOnsData, isLoading: false });
  const [deleteMany] = useDeleteMany();
  const [closeFromParent, setCloseFromParent] = useState<boolean>(false);

  const removeAddon = async (id: string) => {
    try {
      await deleteMany("ServiceAddOn", {
        ids: [id]
      });
    } finally {
      setTimeout(() => {
        refresh();
      }, 500);
    }
  };

  return (
    <div className="bg-mono-primaryBgColor mb-4 rounded-lg pt-4">
      <ListContextProvider value={listContext}>
        <CustomDataGrid
          rowClick={(id: string, resource: any, record: any) =>
            `/dashboard/AddOns/${record?.core_service?.id}/show`
          }
          sx={{
            borderRadius: "0px",
            ".RaDatagrid-headerCell": {
              backgroundColor: "transparent",
              minWidth: "0px",
              fontSize: "14px",
              borderTop: "1px solid rgba(224, 224, 224, 1)",
              "@media screen and (max-width:1280px)": {
                fontSize: "12px"
              }
            },
            ".RaDatagrid-rowCell": {
              minWidth: "0px",
              width: "358px",
              padding: "13px 16px"
            },
            ".RaDatagrid-rowCell:last-child": {
              width: "40px"
            },
            ".RaDatagrid-rowCell span": {
              fontSize: "14px",
              width: "fit-content",
              "@media screen and (max-width:1280px)": {
                fontSize: "12px"
              }
            },
            ".RaDatagrid-row:first-child .MuiTableCell-root": {
              borderTop: "1px solid rgba(224, 224, 224, 1)"
            },
            ".RaDatagrid-row:last-child .MuiTableCell-root": {
              borderWidth: "0px"
            }
          }}
        >
          <FunctionField
            label={translate("services.name")}
            render={(record: any) => (
              <span className="text-[#16667A]">
                {record?.core_service?.name}
              </span>
            )}
          />
          <FunctionField
            label={translate("services.price")}
            render={(record: any) =>
              record?.core_service?.price > 0
                ? `$${record?.core_service?.price}`
                : "Free"
            }
          />
          <FunctionField
            label={translate("services.duration")}
            render={(record: any) => `${record?.core_service?.duration} mins`}
          />
          {!permissions.isArtist && (
            <FunctionField
              render={(record: any) => (
                <div className="flex justify-end">
                  <ListDotsActions
                    closeFromParent={closeFromParent}
                    setCloseFromParent={setCloseFromParent}
                  >
                    <Link to={`/dashboard/AddOns/${record?.core_service?.id}`}>
                      <ListItemButton
                        sx={{
                          fontSize: "14px",
                          fontFamily: "Inter",
                          "& .MuiListItemButton-root": {
                            fontSize: "14px",
                            fontFamily: "Inter"
                          }
                        }}
                      >
                        {translate("common.edit")}
                      </ListItemButton>
                    </Link>
                    <ListItemButton
                      onClick={() => {
                        removeAddon(record?.id);
                        setCloseFromParent(true);
                      }}
                      sx={{
                        fontSize: "14px",
                        fontFamily: "Inter",
                        "& .MuiListItemButton-root": {
                          fontSize: "14px",
                          fontFamily: "Inter"
                        }
                      }}
                    >
                      {translate("common.remove")}
                    </ListItemButton>
                  </ListDotsActions>
                </div>
              )}
            />
          )}
        </CustomDataGrid>
      </ListContextProvider>
    </div>
  );
};

export default ServiceAddOnsList;
